const index = () => import(/* webpackChunkName: "herb" */ './Index');

//2023年省级中小企业发展导向计划
export default {
  routes: [
    {
      path: '/guide/smes/v2022/index',
      name: 'guide_smes_v2022_index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/guide/guide/smes/V2022/router.js